import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import InternalRepatriationsTransactionsContainer from '../internal-repatriations/containers/InternalRepatriationsTransactionsContainer';
import CenterInitiatedRepatriationsTransactionsContainer from '../internal-repatriations/containers/CenterInitiatedRepatriationsTransactionsContainer';
import ManualPreadviceTransactionsContainer from '../manual-preadvice/containers/ManualPreadviceTransactionsContainer';
import BalanceModificationTransactionsContainer from '../balance-modification/containers/BalanceModificationTransactionsContainer';
import PredesTransactionsContainer from '../predes/containers/PredesTransactionsContainer';
import RouteModificationTransactionsContainer from '../route-modification/containers/RouteModificationTransactionsContainer';

let defaultTab = 0;

function TransactionsTabsPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
}

TransactionsTabsPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    minHeight: '445px',
  },
  tab: {
    '& .MuiBox-root': {
      padding: '12px',
    },
  },
}));

export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(defaultTab);

  const handleChange = (event, newValue) => {
    defaultTab = newValue;
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" variant="fullWidth">
          <Tab label="PREDES" {...a11yProps(0)} />
          <Tab label="Manual Preadvice" {...a11yProps(1)} />
          <Tab label="Center Initiated Repatriations" {...a11yProps(2)} />
          <Tab label="Internal Repatriations" {...a11yProps(3)} />
          <Tab label="Balance Modifications" {...a11yProps(4)} />
          <Tab label="Route type Modifications" {...a11yProps(5)} />
        </Tabs>
      </AppBar>
      <TransactionsTabsPanel value={value} index={0} classes={{ root: classes.tab }}>
        <PredesTransactionsContainer />
      </TransactionsTabsPanel>
      <TransactionsTabsPanel value={value} index={1} classes={{ root: classes.tab }}>
        <ManualPreadviceTransactionsContainer />
      </TransactionsTabsPanel>
      <TransactionsTabsPanel value={value} index={2} classes={{ root: classes.tab }}>
        <CenterInitiatedRepatriationsTransactionsContainer />
      </TransactionsTabsPanel>
      <TransactionsTabsPanel value={value} index={3} classes={{ root: classes.tab }}>
        <InternalRepatriationsTransactionsContainer />
      </TransactionsTabsPanel>
      <TransactionsTabsPanel value={value} index={4} classes={{ root: classes.tab }}>
        <BalanceModificationTransactionsContainer />
      </TransactionsTabsPanel>
      <TransactionsTabsPanel value={value} index={5} classes={{ root: classes.tab }}>
        <RouteModificationTransactionsContainer />
      </TransactionsTabsPanel>
    </div>
  );
}
